/** @format */
import { ChangeDetectionStrategy, Component, Inject, Input, Optional, ViewEncapsulation } from '@angular/core';
import { CustomCourseUnitAttainment } from 'common-typescript/types';
import { PLAN_ACTIONS_SERVICE_INJECTION_TOKEN, PlanActionsService } from '../../plan/plan-actions-service/plan-actions.service';

@Component({
    selector: 'sis-custom-course-unit-attainment-details-box',
    templateUrl: './custom-course-unit-attainment-details-box.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CustomCourseUnitAttainmentDetailsBoxComponent {
    @Input({ required: true }) customCourseUnitAttainment: CustomCourseUnitAttainment;

    constructor(@Optional() @Inject(PLAN_ACTIONS_SERVICE_INJECTION_TOKEN) private readonly planActionsService: PlanActionsService) {}

    get canOpenAttainmentDetails(): boolean {
        return !!this.planActionsService?.openCustomCourseUnitAttainmentDetailsModal;
    }

    openAttainmentDetailsModal() {
        this.planActionsService?.openCustomCourseUnitAttainmentDetailsModal?.(this.customCourseUnitAttainment);
    }
}
